<template>
    
    <div>

        <div v-if="init" class="mb-8 my-6">

            <div class="flex">

				<div class="w-7/12 pr-16">

					<form @submit.prevent="submitForm()" action="#">

                        <div class="flex items-center my-2">
							<div class="w-4/12">Full name:</div>
							<div class="w-5/12">
								<input :value="currentUser.name" class="form-input w-full" type="text" placeholder="Full name" required disabled />
							</div>
						</div>

                        <div class="flex items-center my-2">
							<div class="w-4/12">Personal number:</div>
							<div class="w-5/12">
								<input :value="currentUser.number" class="form-input w-1/2" type="number" required disabled />
							</div>
						</div>
                        
                        <div class="flex items-center my-2">
							<div class="w-4/12">Date:</div>
							<div class="w-3/12">
								<datepicker 
                                    v-model="form.from"
                                    :input-class="'form-input w-full'"
                                    :monday-first="true"
                                    :required="true"
                                    :placeholder="'From'"
                                    :highlighted="highlightedDays"
                                    @closed="setFormHours">
                                </datepicker>
							</div>
                            <div class="mx-4">-</div>
							<div class="w-3/12">
								<datepicker
                                    v-model="form.to"
                                    :input-class="'form-input w-full'"
                                    :monday-first="true"
                                    :required="true"
                                    :placeholder="'To'"
                                    :open-date="openDate"
                                    :highlighted="highlightedDays"
                                    :disabled-dates="disableTo"
                                    @closed="setFormHours">
                                </datepicker>
							</div>
						</div>

                        <div class="flex items-center my-2">
							<div class="w-4/12">Hours absent:</div>
							<div class="w-3/12">
								<input v-model="form.hours" class="form-input w-full" type="text" placeholder="Hours" required />
							</div>
                            <div v-if="form.hours" class="ml-3">(<span class="font-bold">{{ daysAbsent }}</span> vacation {{ daysAbsentText }})</div>
                            <!-- <div v-if="form.hours" class="ml-3">(<span class="font-bold">{{ daysAbsent }}</span> vacation {{ daysAbsentText }} / <span class="font-bold">{{numOfVacRemain}}</span> {{ daysRemainText }} will remain)</div> -->
						</div>

                        <div class="flex items-center my-2">
							<div class="w-4/12">Comments:</div>
							<div class="w-8/12">
								<textarea v-model="form.comments" rows="5" class="form-input w-full" type="text" />
							</div>
						</div>

                        <div class="mt-12 flex">

							<button v-if="!vacationKey" class="btn btn-secondary" type="submit">
								<div v-if="saving" class="loader"></div>
                                <span v-else>Request</span>
							</button>

                            <button v-else class="btn btn-secondary" type="submit">
								<div v-if="saving" class="loader"></div>
                                <span v-else>Update</span>
							</button>

                            <router-link :to="{name: 'vacation-list'}" class="mr-2 btn">
								Back
							</router-link>

                        </div>

                    </form>

                </div>

            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

        <SimpleModal v-if="saveModal" @action="saveRequest" @close="saveModal = 0" :btnClass="'btn-secondary'">
            <template v-slot:title>Send vacation request</template>
            <template v-slot:body>Are you sure you want to send vacation request?</template>
            <template v-slot:button>Yes</template>
        </SimpleModal>

        <SimpleModal v-if="editModal" @action="updateRequest" @close="editModal = 0" :btnClass="'btn-secondary'">
            <template v-slot:title>Update vacation request</template>
            <template v-slot:body>Are you sure you want to update vacation request?</template>
            <template v-slot:button>Yes</template>
        </SimpleModal>

    </div>

</template>

<script>
import { mapState, mapGetters } from "vuex";
import { db, auth } from "@/firebase";
import datepicker from 'vuejs-datepicker';
import helper from '../../helpers';
import moment from 'moment';
var Holidays = require('date-holidays')
var hd = new Holidays('CZ')

import SimpleModal from '@/components/SimpleModal.vue'

moment.updateLocale('cs', {
   workingWeekdays: [0, 1, 2, 3, 4]
});

export default {

    data() {
		return {
			form: {
                from: null,
                to: null,
                hours: null,
                comments: null,
                requestedDate: new Date()
            },
            saving: 0,
            saveModal: 0,
            editModal: 0,
            vacationKey: this.$route.params.id || null            
        }
    },

    computed: {
		init() {
			if (this.roles && this.users && this.currentUser) return true
            return false
		},

        numOfVacRemain() {
            if (this.currentUser && this.currentUser.totalVacationsDays) {
                return this.currentUser.totalVacationsDays - this.numOfVacDays - this.daysAbsent;
            }
            return null
        },

        daysAbsent() {
            if (this.form.hours) {
                var workTime = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;
                return Math.round((this.form.hours / workTime) * 100) / 100 ;
            }
        },

        daysAbsentText() {
            if (this.daysAbsent < 2) return 'day';
            if (this.daysAbsent >= 2) return 'days';
        },

        daysRemainText() {
            if (this.numOfVacRemain < 2) return 'day';
            if (this.numOfVacRemain >= 2) return 'days';
        },

        ...mapState({
			currentUser: state => state.user.info,
			currentUserMarktimes: state => state.user.marktimes,
			roles: state => state.roles,
			users: state => state.users,
		}),

        ...mapGetters({
            numOfVacDays: 'numOfVacDays'
        }),

        openDate() {
            if (this.form.from) return this.form.from;
            return new Date();
        },

        disableTo() {
            return {
                to: new Date(this.form.from)
            }
        },

        highlightedDays() {
            return {
                dates: this.holidays
            }
        },

        holidays() {

            var actDate = new Date();
            var lastYear = moment(actDate).add(-1, 'year').year();
            var upcomingYear = moment(actDate).add(1, 'year').year();

            var holidays = hd.getHolidays(lastYear);
            holidays = holidays.concat(hd.getHolidays(actDate.getFullYear()));
            holidays = holidays.concat(hd.getHolidays(upcomingYear));

            var publicHolidays = holidays.filter(holiday => holiday.type === 'public');
            return publicHolidays.map(holiday => moment(holiday.date).toDate())
        },

		currentUser() {
			if (this.users) return this.users.find(user => user.uid === auth.currentUser.uid)
		},

    },

    components: {
        datepicker,
		SimpleModal,
    },

    methods: {
        setFormHours() {
            if (this.form.from && this.form.to) {

                this.form.hours = 0;

                var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;

                var enumerateDaysBetweenDates = function(startDate, endDate) {
                    var dates = [];

                    var currDate = moment(startDate).startOf('day');
                    var lastDate = moment(endDate).startOf('day');

                    while(currDate <= lastDate) {
                        dates.push(currDate.clone().toDate());
                        currDate = currDate.add(1, 'days')
                    }

                    return dates;
                };

                var days = enumerateDaysBetweenDates(this.form.from, this.form.to);

                days.forEach(day => {
                    if (day.getDay() === 6 || day.getDay() === 0) return;
                    if (hd.isHoliday(day)) return;
                    this.form.hours += workingHours;
                })



            }
        },

        submitForm() {
            if (this.vacationKey) this.editModal = 1
            else this.saveModal = 1
        },

        saveRequest() {
            this.saving = 1;

            this.form.user = this.currentUser.uid;

            if (!this.form.user) {
                return this.$toasted.show(`Error: No user found`, {
                    type: 'error'
                })
            }

            db
                .collection('vacations')
                .add(this.form)
                .then(async (ref) => {
                    this.saving = 0;
                    this.saveModal = 0;

                    var marktimeSaved = await this.saveVacationToMarktime();

                    if (marktimeSaved.error) {
                        this.$toasted.show(`There were errors updating marktime!`, {
                            type: 'error'
                        });
                    }

                    this.$router.replace({
                        name: 'vacation-list'
                    });

                    this.$toasted.show(`Saved successfully!`, {
                        type: 'success'
                    });
                })
                .catch((error) => {
                    this.$toasted.show(`Error: ${error}`, {
                        type: 'error'
                    })
                })
        },

        updateRequest() {
            this.saving = 1;

            db
                .collection('vacations')
                .doc(this.vacationKey)
                .update({
                    from: this.form.from,
                    to: this.form.to,
                    comments: this.form.comments,
                    hours: this.form.hours,
                    approved: null,
                    approvedDate: null,
                    approvedBy: null,
                    confirmed: null,
                    confirmedDate: null
                })
                .then(async (ref) => {
                    this.saving = 0;
                    this.editModal = 0;

                    var marktimeSaved = await this.saveVacationToMarktime();

                    if (marktimeSaved.error) {
                        this.$toasted.show(`There were errors updating marktime!`, {
                            type: 'error'
                        });
                    }

                    this.$router.replace({
                        name: 'vacation-list'
                    });

                    this.$toasted.show(`Updated successfully!`, {
                        type: 'success'
                    });
                })
                .catch((error) => {
                    this.$toasted.show(`Error: ${error}`, {
                        type: 'error'
                    })
                })
        },

        findMarktime(month, year) {
            return this.currentUserMarktimes.find(marktime => marktime.year === year && marktime.month === month);
        },

        saveVacationToMarktime() {

            return new Promise(async resolve => {

                if (!this.currentUserMarktimes) return resolve();

                // loop through vacation days
                var from = new Date(this.form.from)
                var to = new Date(this.form.to);

                var marktimesToSave = [];

                var response = {
                    error: 0
                }

                // mutate days
                for (var day = from; day <= to; day.setDate(day.getDate() + 1)) {
                    var year = day.getFullYear();
                    var month = day.getMonth();
                    var today = day.getDate() - 1;
                    var dayInWeek = day.getDay();

                    // find marktime
                    var marktime = this.findMarktime(month, year);
                    if (marktime) {
                        
                        // do not mutate marktime that is already checked by accounter
                        if (marktime.checked) continue;

                        // marktimes to save
                        if (marktimesToSave.indexOf(marktime._key) === -1) {
                            marktimesToSave.push(marktime._key);
                        }
                        
                        var today = marktime.marktime[today];
                        if (today.type != 'S' && dayInWeek != 6 && dayInWeek != 0) {
                            today.type = 'D';
                            today.timeFrom = null;
                            today.timeTo = null;
                            today.timeOff = null;
                            today.overtime = null;
                            today.halfday = false;
                            today.specialHours = false;
                        } 
                    }

                }

                for (let i = 0; i < marktimesToSave.length; i++) {
                    var marktimeSaved = await this.saveMarktime(this.currentUserMarktimes.find(marktime => marktime._key === marktimesToSave[i]));
                    if (marktimeSaved.error) response.error = 1;
                }

                return resolve(response);

            });

        },

        saveMarktime(marktime) {
            return new Promise(resolve => {

                if (!marktime._key) return resolve();

                db
                    .collection("marktimes")
                    .doc(marktime._key)
                    .update(helper.mutateMarktime(marktime))
                    .then(() => {
                        resolve({
                            error: 0
                        })
                    })
                    .catch(error => {
                        resolve({
                            error: 1
                        })
                    });

            });
        }


    },


    created() {
        if (!this.users) this.$store.dispatch('getUsers')
		if (!this.roles) this.$store.dispatch('getRoles')

        if (this.vacationKey) {
            this.$store.commit('SET_TITLE', 'Edit vacation request');

            db
                .collection('vacations')
                .doc(this.vacationKey)
                .get()
                .then(doc => {

                    var data = doc.data();
                    this.form.comments = data.comments;
                    this.form.hours = data.hours;
                    this.form.from = moment(data.from.seconds * 1000).toDate();
                    this.form.to = moment(data.to.seconds * 1000).toDate();

                })

        } else {
            this.$store.commit('SET_TITLE', 'Add new vacation request');
        }
    },


}


</script>

<style>
.vdp-datepicker__calendar .cell.highlighted {
    background: #9AE6B4 !important;
}
</style>